<div class="file-input">
    @if (label) {
        <mat-label>
        {{ label | translate }} <span class="required">{{required ? '*' : ''}}</span>
        </mat-label>
      }
    <input id="file-upload" type="file"
    (change)="afterFileSelect($event)"
    [accept]="acceptFormat.join(',')"
    [multiple]="multiSelect"
    >
</div>
